(function () {
  const SNOW_TIME = 60000;
  const MAX_SNOW = 150;
  const SNOW_SIZE_MIN = 2;
  const SNOW_SIZE_MAX = 6;

  const canvas = document.createElement("canvas");
  canvas.style.position = "fixed";
  canvas.style.left = 0;
  canvas.style.top = 0;
  canvas.style.pointerEvents = "none";
  canvas.style.width = "100%";
  canvas.style.height = "100%";
  canvas.style.zIndex = 999999;
  document.body.appendChild(canvas);

  const ctx = canvas.getContext("2d");

  function resize() {
    canvas.width = window.innerWidth;
    canvas.height = window.innerHeight;
  }
  resize();
  window.addEventListener("resize", resize);

  class Snowflake {
    constructor() {
      this.reset();
    }
    reset() {
      this.x = Math.random() * canvas.width;
      this.y = Math.random() * canvas.height - canvas.height;
      this.size = SNOW_SIZE_MIN + Math.random() * (SNOW_SIZE_MAX - SNOW_SIZE_MIN);
      this.speedY = 0.5 + Math.random() * 1.5;
      this.speedX = Math.random() * 1 - 0.5;
      this.opacity = 0.4 + Math.random() * 0.6;
    }
    update() {
      this.y += this.speedY;
      this.x += this.speedX;

      if (this.y > canvas.height) {
        this.reset();
      }
    }
    draw() {
      ctx.beginPath();
      ctx.fillStyle = `rgba(255,255,255,${this.opacity})`;
      ctx.arc(this.x, this.y, this.size, 0, Math.PI * 2);
      ctx.fill();
    }
  }

  const snowflakes = [];
  for (let i = 0; i < MAX_SNOW; i++) {
    snowflakes.push(new Snowflake());
  }

  let running = true;
  function update() {
    if (!running) return;

    ctx.clearRect(0, 0, canvas.width, canvas.height);

    for (const s of snowflakes) {
      s.update();
      s.draw();
    }

    requestAnimationFrame(update);
  }
  update();

  setTimeout(() => {
    running = false;
    canvas.remove();
  }, SNOW_TIME);
})();
